import { render, staticRenderFns } from "./c-end-privacy.vue?vue&type=template&id=b88c329e&"
import script from "./c-end-privacy.vue?vue&type=script&lang=js&"
export * from "./c-end-privacy.vue?vue&type=script&lang=js&"
import style0 from "./c-end-privacy.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports